<template>
  <simple-page header="设备节电率统计表"
               help-text="计算说明"
               @help-click="helpClick"
               backable
               @query="query"
               @reset="reset">
    <template #buttons>
      <el-button type="primary" icon="fa fa-download" :loading="loading" @click="download">导出</el-button>
    </template>
    <template #form>
      <el-form v-model="queryForm" inline>
        <el-form-item label="所属单位">
          <comp-select v-model="queryForm.compIds" multiple collapse-tags></comp-select>
        </el-form-item>
        <el-form-item label="统计年月">
          <el-date-picker v-model="queryForm.startYearMonth" type="month"
                          :clearable="false"
                          value-format="yyyyMM"
                          style="width: 140px"
                          clearable
                          format="yyyy年MM月"></el-date-picker>
          至
          <el-date-picker v-model="queryForm.endYearMonth" type="month"
                          :clearable="false"
                          value-format="yyyyMM"
                          style="width: 140px"
                          clearable
                          format="yyyy年MM月"></el-date-picker>
        </el-form-item>
      </el-form>
    </template>

    <template #formMore>
      <el-form v-model="queryForm" inline>
        <el-form-item label="设备类型">
          <code-select code-type="DEVICE_TYPE" v-model="queryForm.deviceType"></code-select>
        </el-form-item>
        <el-form-item label="设备编号">
          <el-input v-model.trim="queryForm.deviceCode"></el-input>
        </el-form-item>
      </el-form>
    </template>

      <el-table stripe :data="records" :border="true" v-loading="loading">
        <el-table-column type="index" label="序号" width="50" align="center" fixed></el-table-column>
        <el-table-column prop="compName" label="单位名称" min-width="130" fixed></el-table-column>
        <el-table-column prop="deviceCode" label="设备编号" align="center" width="130" fixed v-slot="{row}">
          <el-link type="primary" @click="showDetail(row)">{{row.deviceCode}}</el-link>
        </el-table-column>
<!--        <el-table-column prop="deviceName" label="设备名称" min-width="120"></el-table-column>-->
        <el-table-column prop="address" label="地址" min-width="150"></el-table-column>
        <el-table-column prop="y" label="年月" align="center" min-width="100" v-slot="{row}">
          <span>{{row.y}}年{{row.m}}月</span>
        </el-table-column>
        <el-table-column prop="acCount" label="空调数量" align="center" min-width="80" v-slot="{row}">
          {{row.acCount}}台,{{row.acPower}}W
        </el-table-column>
        <el-table-column prop="inFanCount" label="新风数量" align="center" min-width="80" v-slot="{row}">
          {{row.inFanCount}}台
        </el-table-column>
        <el-table-column prop="maxInTemp" label="最高室内温度" align="center" min-width="80"></el-table-column>
        <el-table-column prop="maxOutTemp" label="最高室外温度" align="center" min-width="80"></el-table-column>
        <el-table-column prop="maxInWet" label="最高湿度" align="center" min-width="80"></el-table-column>
        <el-table-column prop="kwh" label="本月电表(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="monthKwh" label="本月电量(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="acAvgKwh" label="空调日耗电量(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="normalAvgKwh" label="联动日耗电量(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="saveAvgKwh" label="日节电量(KWH)" align="center" min-width="90"></el-table-column>
        <el-table-column prop="savePercent" label="节电率(%)" align="center" min-width="90" v-slot="{row}">
          <span v-if="row.savePercent">{{row.savePercent}}%</span>
        </el-table-column>
        <el-table-column prop="saveKwh" label="本月节电量(KWH)" align="center" min-width="90"></el-table-column>
      </el-table>
      <table-pagination :page-query="queryForm" :total="total" @change="loadData"></table-pagination>

    <el-drawer :visible.sync="showDescribe" direction="rtl" size="30%" title="计算公式说明" style="line-height: 28px">
      节电率 =（日均单开空调能耗（KWH）- 日均新风联动空调运行能耗（KWH））/ 日均单开空调能耗（KWH）* 100%
      <br/><br/>
      节电量 =（空调日均电量 - 新风空调联动日均电量）* 统计天数
    </el-drawer>
  </simple-page>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
import CompSelect from "@/components/base/CompSelect";
import CodeSelect from "@/components/base/CodeSelect.vue";
import SessionStore from "@/utils/SessionStore";
import * as querystring from "querystringify";
import SimplePage from "@/components/page/SimplePage.vue";
export default {
  components: {SimplePage, CodeSelect, CompSelect, TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      showDescribe: false,
      storeKey: "device-month-info",
      queryForm: {
        compIds: null,
        deviceType: '',
        deviceCode: '',
        startYearMonth: new Date().getFullYear()+"01",
        endYearMonth: new Date().format("yyyyMM"),
        page: 1,
        limit: 10
      },
      total: 0,
      records: []
    }
  },
  created() {
    let params = SessionStore.getObjectAndClear(this.storeKey);
    if(!!params) {
      this.queryForm = params;
    }
    this.query();
  },
  methods: {
    query(){
      this.queryForm.page = 1;
      this.loadData();
    },
    loadData() {
      this.loading = true;
      this.postForm("/device-month-info/list", this.queryForm, true).then(dr => {
        this.records = dr.rows;
        this.total = dr.total;
      }).finally(()=>{
        this.loading = false;
      })
    },
    reset() {
      this.queryForm = {
        compIds: null,
        deviceType: '',
        deviceCode: '',
        startYearMonth: new Date().getFullYear()+"01",
        endYearMonth: new Date().format("yyyyMM"),
        page: 1,
        limit: 10
      }
    },
    download() {
      let params = querystring.stringify(this.queryForm || {});
      window.open(this.globalConfig.apiRoot+"/device-month-info/export?"+params);
    },
    showDetail(row) {
      SessionStore.setObject(this.storeKey, this.queryForm);
      this.$router.push({
        path: '/deviceDayInfo',
        query: {
          deviceCode: row.deviceCode,
          startYearMonth: this.queryForm.startYearMonth,
          endYearMonth: this.queryForm.endYearMonth
        }
      })
    },
    helpClick() {
      console.log("helpClick")
      this.showDescribe = true;
    }
  }
}
</script>

<style scoped>

</style>